import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookPivotTableStoreFactory('sessions')
  .extendReportViewFactory('session-pivot')
  .factory()

export {
  Provider as SessionPivotProvider,
  useStore as useSessionPivotStore,
}
